/*
 * @Description: 支付相关接口(vip支付和商品支付分开了)
 * @Author: 王逢超 wangfengchao@nextmar.com
 * @Date: 2022-06-21 11:41:29
 */
import type { ApplePayPaymentMethodsParams, ApplePaySessionParams } from '@/api/types/pay';
import { httpRequest, request } from '../request';

const paypal = {
  token: (data: unknown) => request('/api/paypal_usa/pay', 'post', data),
  vip_token: (data: unknown) => request('/api/paypal_usa/vip_pay', 'post', data),
  pay: (data: unknown) => request('/api/paypal_usa/deduction', 'post', data),
  vip_pay: (data: unknown) => request('/api/paypal_usa/vip_deduction', 'post', data),
  // 补差价接口
  diff_token: (data: unknown) =>
    request('/api/paypal_usa/difference_pay', 'post', data, { errorMsg: false }),
  diff_pay: (data: unknown) => request('/api/paypal_usa/difference_deduction', 'post', data),
};
const klarna = {
  session: (data: unknown) =>
    request('/api/klarna_usa/create_session', 'post', data, { errorMsg: false }),
  pay: (data: unknown) => request('/api/klarna_usa/pay', 'post', data),
};
const adyen = {
  paymentMethods: (data: unknown) => request('/api/adyen_usa/get_payment_methods', 'post', data),
  vip_paymentMethods: (data: unknown) =>
    request('/api/adyen_usa/vip_get_payment_methods', 'post', data),
  pay: (data: unknown) => request('/api/adyen_usa/credit_card_pay', 'post', data),
  vip_pay: (data: unknown) => request('/api/adyen_usa/vip_credit_card_pay', 'post', data),
  diff_paymentMethods: (data: unknown) =>
    request('/api/adyen_usa/difference_pay_param', 'post', data, { errorMsg: false }),
  diff_pay: (data: unknown) => request('/api/adyen_usa/difference_credit_card_pay', 'post', data),
  adyenKlarnaSession: (data: unknown) => request('/api/adyen_usa/klarna_session', 'post', data),
};
const apple = {
  paymentMethods: (data: ApplePayPaymentMethodsParams) =>
    httpRequest('POST:/api/adyen_usa/is_show_pays', { data }, { errorMsg: false }),
  session: (data: ApplePaySessionParams) =>
    httpRequest('POST:/api/adyen_usa/get_payment_session', { data }),
};
const afterpay = {
  getUrl: (data: unknown) => request('/api/adyen_usa/after_pay', 'post', data),
  detail: (data: unknown) =>
    request('/api/adyen_usa/pay_detail', 'post', data, { errorMsg: false }),
  diff_detail: (data: unknown) => request('/api/adyen_usa/difference_pay_detail', 'post', data),
};
/* 补差价接口 */
const difference = {
  createOrder: (data: unknown) =>
    request('/api/public/difference', 'post', data, { errorMsg: false }),
  check: (data: unknown) => request('/api/public/check_difference_order_link', 'post', data),
  diffPrice: (data: unknown) =>
    request('/api/public/difference_price', 'post', data, { errorMsg: false }),
};

// 支付中台 -  获取可用的支付方式
const payCenter = {
  paymentMethodsList: () => request('/api/pay_center/payment_methods', 'get'),
  payDetail: (data: unknown) => request('/api/pay_center/pay/detail', 'post', data),
};

/** 获取魔方配置可用支付方法 */
const allowPaymentMethod = () =>
  request('/api/public/payment_method', 'get', {}, { errorMsg: false });

export default {
  paypal,
  klarna,
  adyen,
  apple,
  afterpay,
  difference,
  allowPaymentMethod,
  payCenter,
};
